@if (eventModel && eventModel.OrganizationId) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <risk-linkable
            #linkableRisks
            typename="risks"
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [orderByValueProperty]="true"
            [disabled]="disabled"
            (linkedChange)="linkedItemsChanged($event)"
            (onLinkedClick)="editLinked($event)"
            (onBatchClicked)="openBatchEdit()"
        >
        </risk-linkable>
    }
}
